import validations from 'helpers/forms/validations';

export default (() => {
    const ACCESS_METHOD_KIESTRA = 1;
    const ACCESS_METHOD_AXA_SLOT_NAZZA = 2;
    const ACCESS_METHOD_BRIVO = 3;
    const ACCESS_METHOD_VICKY = 4;
    const ACCESS_METHOD_TRANZER = 5;
    const ACCESS_METHOD_BRIVO_LICENSE_PLATE = 6;
    const ACCESS_METHOD_WPS = 7;
    const ACCESS_METHOD_BLUEMARBLE = 10;
    const ACCESS_METHOD_YESPARK = 11;
    const ACCESS_METHOD_PARKBEE = 12;
    const ACCESS_METHOD_TRANZER_HTM = 14;
    const ACCESS_METHOD_NAZZA_HSF = 15;
    const ACCESS_METHOD_MYWAY = 16;
    const ACCESS_METHOD_MOBIHOUSE_BOOKING = 17;
    const ACCESS_METHOD_MOBIHOUSE_BOOKING_SLIMPARKEREN = 18;

    const accessMethods = {
        [ACCESS_METHOD_KIESTRA]: 'Kiestra XR',
        [ACCESS_METHOD_AXA_SLOT_NAZZA]: 'AXA Slot (Nazza)',
        [ACCESS_METHOD_BRIVO]: 'Brivo',
        [ACCESS_METHOD_VICKY]: 'Vicky',
        [ACCESS_METHOD_TRANZER]: 'Tranzer',
        [ACCESS_METHOD_BRIVO_LICENSE_PLATE]: 'Brivo License Plate',
        [ACCESS_METHOD_WPS]: 'WPS',
        [ACCESS_METHOD_BLUEMARBLE]: 'Bluemarble',
        [ACCESS_METHOD_YESPARK]: 'YesPark',
        [ACCESS_METHOD_PARKBEE]: 'ParkBee',
        [ACCESS_METHOD_NAZZA_HSF]: 'AXA Slot (Nazza HSF)',
        [ACCESS_METHOD_MYWAY]: 'MyWay',
        [ACCESS_METHOD_TRANZER_HTM]: 'Tranzer HTM',
        [ACCESS_METHOD_MOBIHOUSE_BOOKING]: 'Mobihouse Booking',
        [ACCESS_METHOD_MOBIHOUSE_BOOKING_SLIMPARKEREN]: 'Mobihouse Booking Slimparkeren',
    };

    const DIRECTION_ENTER_EXIT = 1;
    const DIRECTION_ENTER = 2;
    const DIRECTION_EXIT = 3;

    const settings = {
        [ACCESS_METHOD_KIESTRA]: {
            phone: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_AXA_SLOT_NAZZA]: {
            depot_id: {
                validations: [
                    validations.required,
                    validations.number,
                ],
            },
        },
        [ACCESS_METHOD_NAZZA_HSF]: {
            depot_id: {
                validations: [
                    validations.required,
                    validations.number,
                ],
            },
        },
        [ACCESS_METHOD_BRIVO]: {
            access_point_id: {
                validations: [
                    validations.required,
                    validations.number,
                ],
            },
        },
        [ACCESS_METHOD_VICKY]: {
            gate_id: {
                validations: [
                    validations.required,
                ],
            },
        },
        [ACCESS_METHOD_TRANZER]: {
            product_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_TRANZER_HTM]: {
            product_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_BRIVO_LICENSE_PLATE]: {
            access_point_id: {
                validations: [
                    validations.required,
                    validations.number,
                ],
            },
        },
        [ACCESS_METHOD_WPS]: {
            station_id: {
                validations: validations.required,
            },
            carpark_id: {
                validations: validations.required,
            },
            custom_counter_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_BLUEMARBLE]: {
            location_id: {
                validations: validations.required,
            },
            connector_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_YESPARK]: {
            subscription_id: {
                validations: validations.required,
            },
            access_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_PARKBEE]: {
            depot_id: {
                validations: validations.required,
            },
            door_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_MYWAY]: {
            gate_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_MOBIHOUSE_BOOKING]: {
            access_point_access_method_id: {
                validations: validations.required,
            },
        },
        [ACCESS_METHOD_MOBIHOUSE_BOOKING_SLIMPARKEREN]: {
            access_point_access_method_id: {
                validations: validations.required,
            },
        },
    };

    return {
        exists: function (id) {
            return id && !!accessMethods[id];
        },
        getMethodName: function (id) {
            if (!this.exists(id)) {
                return;
            }

            return accessMethods[id];
        },
        getAccessMethods: () => {
            return accessMethods;
        },
        getDirectionIDs: function (selected_method) {
            if (selected_method && this.isTranzer(selected_method)) {
                return [
                    DIRECTION_ENTER_EXIT,
                ];
            }

            return [
                DIRECTION_ENTER_EXIT,
                DIRECTION_ENTER,
                DIRECTION_EXIT,
            ];
        },
        getSettings: function (access_method) {
            if (!access_method || !accessMethods[access_method]) {
                return {};
            }

            return settings[access_method];
        },
        isDirectionEnter: function (direction) {
            return direction === DIRECTION_ENTER;
        },
        isTranzer: function (access_method) {
            return access_method === ACCESS_METHOD_TRANZER;
        },
        isAllowedForceBarrier: function (access_method) {
            return [
                ACCESS_METHOD_MYWAY,
                ACCESS_METHOD_PARKBEE,
                ACCESS_METHOD_BRIVO,
                ACCESS_METHOD_BRIVO_LICENSE_PLATE,
                ACCESS_METHOD_VICKY,
                ACCESS_METHOD_WPS,
            ].includes(access_method);
        },
    };
})();



// WEBPACK FOOTER //
// ./src/helpers/accessMethodsHelper.js